var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzureDevopsSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure-devops-color-16__paint0_linear_707_116)",
    d: "M15 3.622v8.512L11.5 15l-5.425-1.975v1.958L3.004 10.97l8.951.7V4.005L15 3.622zm-2.984.428L6.994 1v2.001L2.382 4.356 1 6.13v4.029l1.978.873V5.869l9.038-1.818z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-devops-color-16__paint0_linear_707_116",
    x1: 8,
    x2: 8,
    y1: 14.956,
    y2: 1.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3C91E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EA0EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureDevopsSvgrepoCom);
export default __webpack_public_path__ + "static/media/azure-devops-svgrepo-com.eb929115f2eaef8a45f92ed12ea4e14d.svg";
export { ForwardRef as ReactComponent };